module.exports = function() {
  return new Worker(__webpack_public_path__ + "b7fb89776b9534b0aa6a.worker.js");
};